export interface NewsItem {
  id: string;
  slug: string;
  title: string;
  date: string;
  dateLabel: string;
  location: string;
  image: string;
  category?: "PRESSE" | "PROJEKT" | "UNTERNEHMEN";


  excerpt?: string;
  lead?: string;

  body: string[];
  gallery?: string[];
}

export const newsItems: NewsItem[] = [
 
  {
  id: "haus-bethanien-einweihung",
  slug: "haus-bethanien-einweihung",

  title:
    "Die „Kleine Blume von Bethanien“ blüht in Klink an der Müritz in Mecklenburg – Feierliche Einweihung und Segnung des neuen Schwesternwohnhauses „Haus Bethanien“ in Klink",

  date: "2025-08-15",
  dateLabel: "15.08.2025",
  location: "Klink",
  category: "PROJEKT",

  image: "/media/aktuelles/haus-bethanien-einweihung-1-vert.jpg",

  excerpt:
    "Am Hochfest der Mariä Himmelfahrt wurden Kapelle, Haus und Zimmer der Schwestern im neuen Schwesternwohnhaus „Haus Bethanien“ in Klink feierlich eingeweiht und gesegnet.",


  body: [
    "Klink, 15.08.2025 – Am Hochfest der Mariä Himmelfahrt wurde in der Kapelle des noch im Bau befindlichen Schwesternwohnhauses „Haus Bethanien“ der Ordensgemeinschaft „Little Flower of Bethany“ eine feierliche Heilige Messe gefeiert – verbunden mit der Segnung von Kapelle, Haus und den privaten Zimmern der Schwestern.",
    "Zu diesem besonderen Anlass versammelten sich Generalvikar P. Sascha-Philipp Geißler SAC vom Erzbistum Hamburg, Pfarrer Bruder Martin Walz von der Katholischen Pfarrei Seliger Niels Stensen aus Waren, die drei künftig dort lebenden Ordensschwestern Sr. Blecilla, Sr. Shanthi und Sr. Savitha, weitere Schwestern der Gemeinschaft aus Berlin und Aachen sowie Vertreter des Bauherrn und der Müritz Klinik.",
    "Obwohl das Haus noch nicht vollständig fertiggestellt ist, war die Messe ein bedeutender Moment der Hoffnung, des Dankes und der Vorfreude auf das zukünftige Zuhause der Schwestern. Schon jetzt sind die drei Ordensfrauen in der Müritz Klinik als Seelsorgerin und Krankenschwestern tätig, doch das neue Wohnhaus wird ihnen bald einen eigenen, geschützten Lebensraum bieten. In den kommenden Monaten sollen weitere Schwestern der Gemeinschaft einziehen und „Haus Bethanien“ mit Leben füllen.",
    "In einer Zeit, in der die Klöster eher schließen als eröffnen, unterstrich Generalvikar Geißler in seiner Ansprache die geistliche Dimension des Neubeginns mit einem Zitat: „Mit beiden Beinen auf der Erde, mit den Augen zum Himmel und mit dem Herzen bei den Menschen.“ Mit der Eröffnung des „Haus Bethanien“ ist nun die einzige Schwesterngemeinschaft in Mecklenburg angesiedelt.",
    "Dr. Douglas Fernando, Bauherr und Vorstand der AVILA-Gruppe, sagte: „Die Messe war ein symbolischer Schritt auf dem Weg zur Fertigstellung des Hauses und ein Moment der Dankbarkeit für den bisherigen Fortschritt. Auch wenn die Schwestern noch nicht einziehen können, war dieser Gottesdienst ein bedeutender Ausdruck von Gemeinschaft und Segen für die kommende Zeit.“",
    "Die vollständige Fertigstellung und der Einzug der Schwestern sind für Ende Dezember 2025 geplant. Darüber hinaus soll „Haus Bethanien“ künftig auch ein Ort der Begegnung und des Austauschs werden – offen für Gäste, mit Raum für Ruhe, Gemeinschaft und geistliche Einkehr.",
    "Die „Sisters of the Little Flower of Bethany“ sind eine indische Frauenkongregation päpstlichen Rechts, die am 16. Juli 1921 von Pater RFC Mascarenhas in Indien gegründet wurde. Heute leben und wirken die Schwestern in 47 indischen und acht Diözesen im Ausland, darunter jetzt drei Niederlassungen in Deutschland. Der Ordensname geht auf die Hl. Thérèse von Lisieux zurück. Sie war Karmelitin und wurde im Volksmund die kleine Blume Jesu genannt."
  ],


  gallery: [
    "/media/aktuelles/haus-bethanien-einweihung-1-vert.jpg",
    "/media/aktuelles/haus-bethanien-einweihung-2-vert.jpg",
  ]
},
 {
    id: "haus-bethanien-grundstein",
    slug: "haus-bethanien-grundstein",

    title:
      "Grundsteinlegung für das „Haus Bethanien“ im Gesundheits- und Erholungspark am Müritzufer in Klink",

    date: "2023-06-03",
    dateLabel: "03.06.2023",
    location: "Klink",

    category: "PROJEKT",


    image: "/media/aktuelles/haus-bethanien-grundstein-1.jpg",

    excerpt:
      "Am 02. Juni 2023 wurde im Gesundheits- und Erholungspark am Müritzufer in Klink die Grundsteinlegung für das neue Wohnhaus der Ordensgemeinschaft „Schwestern der kleinen Blume von Bethanien“ gefeiert.",

    body: [
      "Klink, 03.06.2023 – Am 02. Juni 2023 wurde auf dem Areal des Gesundheits- und Erholungsparks am Müritzufer in Klink ein weiterer Meilenstein erreicht: Die Grundsteinlegung für das neue Wohnhaus der Ordensgemeinschaft „Schwestern der kleinen Blume von Bethanien“ sowie die Segnung des Bauplatzes fanden in einer feierlichen Zeremonie statt.",

      "Mit großer Vorfreude und symbolischer Bedeutung wurde die kupferne Zeitkapsel in die Bodenplatte des neuen Gebäudes eingelassen. Sie enthält wertvolle Zeitdokumente wie aktuelle Zeitungen, Münzen, Handwerkszeug sowie einen Mikrofilm mit Baugenehmigung und Plänen des Bauvorhabens. Ein Kreuz, als Symbol der christlichen Glaubensgemeinschaft, wurde ebenfalls hinzugefügt, ebenso wie Dokumente und Erinnerungsstücke der Ordensgemeinschaft, die ihre Geschichte und Identität widerspiegeln.",

      "Nach dem traditionellen Einschließen der Kapsel in den Hohlraum der Bodenplatte versiegelten die Teilnehmer der Zeremonie ihre Wünsche mit einem symbolischen dreifachen Klopfen auf den Deckel. Dr. Douglas Fernando, Bauherr und Vorsitzender der AVILA Management & Consulting AG, gab anschließend den Namen des neuen Gebäudes bekannt: „Haus Bethanien“.",

      "Das „Haus Bethanien“ wird künftig als Wohnort für die Schwestern sowie als offener Begegnungsort für Gäste dienen – ein Raum für Austausch, Erholung und Gemeinschaft.",

      "Wir möchten uns bei allen Teilnehmern für das gelungene Event und die vielen inspirierenden Eindrücke bedanken und freuen uns auf die kommenden Schritte dieses besonderen Projekts."
    ],

  
    gallery: [
      "/media/aktuelles/haus-bethanien-grundstein-1.jpg",
    ]
  },

{
  id: "dorint-klink-grundsteinlegung",
  slug: "dorint-klink-grundsteinlegung",

  title:
    "Grundsteinlegung für das „Dorint Seehotel & Resort Klink a.d. Müritz“: Ein neuer Meilenstein für den Tourismus an der Müritz",

  date: "2022-09-29",
  dateLabel: "29.09.2022",
  location: "Klink",
  category: "PROJEKT",

  image: "/media/aktuelles/dorint-grundstein-1.jpg",

  excerpt:
    "Am 28. September 2022 wurde mit der Grundsteinlegung für das neue 4-Sterne-Superior „Dorint Seehotel & Resort Klink a.d. Müritz“ ein wichtiger Meilenstein für die touristische Entwicklung der Region gesetzt.",

  body: [
    "Klink, 29.09.2022 – Am 28. September 2022 wurde auf dem Areal des Gesundheits- und Erholungsparks am Müritzufer in Klink ein bedeutender Meilenstein erreicht: die Grundsteinlegung für das neue 4-Sterne-Superior Ferien- und Konferenzhotel „Dorint Seehotel & Resort Klink a.d. Müritz“. Auf den Tag genau fünf Jahre zuvor wurde das alte FDGB-Hotel gesprengt, um Platz für den Neubau zu schaffen. „Ich habe das alte Hotel hier sprengen lassen, um ein neues, viel schöneres Hotel zu bauen“, so Dr. Douglas Fernando, Bauherr und Vorstand der AVILA-Gruppe, der das Projekt maßgeblich vorantreibt.",
    "Gleichzeitig markierte dieser Tag den symbolischen Start für weitere geplante Projekte, darunter luxuriöse Ferienwohnungen, 63 Personalwohnungen und ein Gebäude für die Ordensschwestern, die bereits in der benachbarten Müritz Klinik tätig sind.",
    "„Mit dem geplanten Vorhaben wird die touristische Angebotsstruktur in Klink nachhaltig erweitert. Dies kommt nicht nur Klink zugute, sondern stärkt auch die Mecklenburgische Seenplatte als Ganzes. Das neue Hotel wird sowohl für Einheimische als auch für Gäste noch attraktiver. Der geplante Wellnessbereich, Fitnessangebote und die vielseitigen Tagungsmöglichkeiten machen das Hotel zu einem ganzjährigen Anziehungspunkt, auch außerhalb der Hauptsaison. Wir brauchen mehr Angebote, die die Nebensaison beleben und somit für eine höhere Auslastung der Beherbergungsstätten sorgen“, erklärte Jochen Schulte, Staatssekretär im Ministerium für Wirtschaft, Infrastruktur, Tourismus und Arbeit, während der Zeremonie.",
    "Die Grundsteinlegung ist eine Zeremonie mit langer Geschichte und eine der ältesten Bautraditionen überhaupt. Auch wir pflegen diesen Brauch als symbolischen Beginn des Bauvorhabens und verbinden die Grundsteinlegung mit religiösen Segen und den Wünschen der Projektbeteiligten, Vertretern aus Politik, Wirtschaft und Kirche auch in Klink wurde dieser Brauch fortgeführt.",
    "Gemeinsam mit Projektbeteiligten, Vertretern aus Wirtschaft, Politik und dem kirchlichen Umfeld wurden Erinnerungsstücke und persönliche Gegenstände in eine kupferfarbene Zeitkapsel gelegt. Zu den Schätzen, die symbolisch für die Verbindung von Vergangenheit und Zukunft stehen, gehörten eine Dorint-Uhr, Münzen, ein alter Mauerstein sowie kirchliche Dokumente. Auch Erinnerungsstücke an das ehemalige Gebäude, wie tagesaktuelle Zeitungen und die Baugenehmigung, fanden ihren Platz in der „Schatztruhe“. Ein Kreuz, als Symbol der Christenheit und als Fundament der Unternehmensphilosophie, wurde ebenfalls in die Kapsel gelegt.",
    "Nachdem die Zeitkapsel in den Hohlraum der Bodenplatte eingelassen wurde, versiegelten die Teilnehmer ihre Wünsche und Segenswünsche mit einem dreifachen Klopfen auf den Deckel. Anschließend nutzten die Anwesenden die Gelegenheit für anregende Gespräche und den Austausch von Eindrücken.",
    "Wir bedanken uns herzlich bei allen Beteiligten und Gästen für dieses unvergessliche Ereignis. Die Grundsteinlegung ist nur der erste Schritt in einem spannenden Entwicklungsprozess, den wir mit viel Engagement und Freude weiterverfolgen. Wir freuen uns darauf, bald die nächsten Meilensteine dieses Projekts gemeinsam zu feiern."
  ],

  gallery: [
    "/media/aktuelles/dorint-grundstein-1.jpg",

  ]
}

];
